import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Slider from "react-slick";

// Components //
import SimpleCard from "../../molecules/simple-card/simpleCard";

// Styles //
import "./bibliotecaRecommendation.scss";

const BibliotecaRecommendation = (props: ReferenciaContenido) => {
    const { contentful_id, tematica } = props.referenciaMultimedia[0];
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);
    const [listItems, setListItems] = useState([]);

    const goToNext = () => {
        if (sliderIndex < slider.props.children.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const CarouselGeneral = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        arrows: false,
        slidesToScroll: 3,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,   
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    function shuffleArray (arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const r = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[r]] = [arr[r], arr[i]];
        }
        return arr;
    }

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children.length - 1;

    const isBrowser = typeof window !== "undefined"
    const pathName = isBrowser ? window.location.pathname: ''

    const data = useStaticQuery(graphql`
        query BIBLIOTECASCONTENIDO {
            empresas: allContentfulSubcategorias(filter: {contentful_id: {eq: "375byUYeLcAQQ0m8BX1vLf"}}) {
                edges {
                    node {
                        id
                        referenciaSubcategorias {
                            slug
                            referenciaSubcategorias {
                                slug
                                referenciaInterna {
                                    referenciaCabecera {
                                        referenciaMultimedia {
                                            contentful_id
                                            tituloMultimedia
                                            tematica
                                            categoriaMultimedia
                                            imagenPrincipal {
                                                file {
                                                    url
                                                }
                                            }
                                        }      
                                    }
                                }
                            }
                        }
                    }
                }
            }
            personas: allContentfulSubcategorias(filter: {contentful_id: {eq: "7KHkTe0HcCUf8Xhn7NvwGC"}}) {
                edges {
                    node {
                        id
                        referenciaSubcategorias {
                            slug
                            referenciaSubcategorias {
                                slug
                                referenciaInterna {
                                    referenciaCabecera {
                                        referenciaMultimedia {
                                            contentful_id
                                            tituloMultimedia
                                            tematica
                                            categoriaMultimedia
                                            imagenPrincipal {
                                                file {
                                                url
                                                }
                                            }
                                        }      
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }`
    );

    function getListSubcategorias(array, key) {
        return array.flatMap(obj => {
            const subCategories = obj[key];
            const parentSlug = obj.slug;
            return subCategories.map(value => ({ ...value.referenciaInterna.referenciaCabecera.referenciaMultimedia, parentSlug, slug: value.slug }));
        });
    }
        
    // Data preparation for recommended content
    useEffect(() => {
        setListItems(getListSubcategorias([...data.empresas.edges[0].node.referenciaSubcategorias, ...data.personas.edges[0].node.referenciaSubcategorias], 'referenciaSubcategorias'))
    }, [contentful_id, tematica]);
        
    return(
        <>
            {(listItems && listItems.length > 0) ? (
                <div className={"o-biblioteca-recommendation"}>
                    <div className="container">
                        <div className="o-biblioteca-recommendation__container">
                            <div className="arrows-slider">
                                <div className="arrows-slider-label">
                                    <h2>También te puede interesar...</h2>
                                </div>
                                <div className="arrows-slider-arrows">
                                <span
                                    className={`arrow icon-chevron-left ${isActiveBack() ? "active" : ""} gtm_navegar_atras_internabiblio_${pathName.split('/')[2]}`}
                                    onClick={goToBack}
                                ></span>
                                <span
                                    className={`arrow  icon-chevron-right  ${isActiveNext() ? "active" : ""} gtm_navegar_adelante_internabiblio_${pathName.split('/')[2]}`}
                                    onClick={goToNext}
                                ></span>
                                </div>
                            </div>
                            <Slider
                                {...CarouselGeneral}
                                ref={(c) => {
                                setSlider(c);
                            }}
                                >
                            {listItems.length > 0 && listItems.slice(0,6).map(
                                (item: any, i) => (
                                    item.tematica === tematica && item.contentful_id !== contentful_id && (
                                        <SimpleCard 
                                            key={i} 
                                            title={item.tituloMultimedia}
                                            image={item.imagenPrincipal.file.url}
                                            theme={item.tematica}
                                            link={`../../${item.parentSlug}${item.slug}`}
                                        />
                                    )
                                )
                            )}
                            </Slider>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
      
}

export default BibliotecaRecommendation;
